<emerald-button
  *ngIf="showViewButton()"
  [type]="'Light'"
  [label]="buttonLabel"
  [size]="'Small'"
  [icon]="buttonIcon"
  [iconFillType]="'outlined'"
  (onClick)="getFeedback()"
></emerald-button>

<emerald-modal [opened]="opened" (onDismiss)="opened = false">
  <section class="feedback-content">
    <div class="status-section">
      <div class="status-badge">
        <div class="status-icon">
          <div [ngClass]="getStatusClass(candidateStatus)"></div>
        </div>
        <span class="status-text">{{ candidateStatus }}</span>
      </div>
    </div>
    <ng-container>
      <div class="candidate-info">
        <span class="candidate-name"><strong>{{ candidateName }}</strong></span>
        <div class="ci-meta">
          <span class="ci-item"><span class="ci-k">Position:</span> <span class="ci-v">{{ position }}</span></span>
        </div>
        <hr />
      </div>
      <div class="scrollbar" #timeline>
        <div
          class="step completed"
          *ngFor="let feedback of feedbackComments; let last = last; let isFirst = first"
        >
          <div class="v-stepper">
            <div class="outer" [ngClass]="{ 'last-element': last }">
              <div class="inner"></div>
            </div>
            <div class="line"></div>
          </div>

          <div class="content">
            <span><strong>{{ feedback?.title }}</strong></span>
            <ng-container *ngIf="feedback?.interviewDate || feedback?.interviewTime; else normalFeedback">
              <p class="feedback">
                <span>Interview Date: {{ feedback?.interviewDate }} , Time: {{ formatTimeTo12Hour(feedback?.interviewTime || '') }}</span>
                <span *ngIf="feedback?.interviewMode"> , Mode: {{ feedback?.interviewMode }}</span>
              </p>
              <p class="info">
                <strong>{{ feedback?.updatedDate }} {{ feedback?.updatedBy }}</strong>
              </p>
            </ng-container>
            <ng-template #normalFeedback>
              <p class="feedback">{{ feedback?.content }}</p>
              <p class="info">
                <strong>{{ feedback?.updatedDate }} {{ feedback?.updatedBy }}</strong>
              </p>
            </ng-template>
          </div>
        </div>
      </div>

      <form class="feedback-form" [formGroup]="feedbackForm">
        <div class="action-section">
          <div class="as-head">Move candidate to</div>
          <div class="action-buttons">
            <ng-container *ngIf="feedbackPopUp()">
              <emerald-button
                *ngIf="candidateStatus === status.ProfileReview"
                size="Medium"
                [type]="selectedButton === status.Shortlist ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="Shortlist"
                className="buttons"
                (onClick)="handleButtonClick(status.ProfileShortlisted, status.ProfileShortlisted); selectedButton = status.Shortlist"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL1ScheduleButton()"
                size="Medium"
                [type]="selectedButton === status.L1Schedule ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L1 Schedule"
                (onClick)="handleButtonClick(status.L1Schedule, status.L1Pending); selectedButton = status.L1Schedule"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL1SelectedButton()"
                size="Medium"
                [type]="selectedButton === status.L1Feedback ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L1 Selected"
                (onClick)="handleButtonClick(status.L1Feedback, status.L2Pending); selectedButton = status.L1Feedback"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL2ScheduleButton()"
                size="Medium"
                [type]="selectedButton === status.L2Schedule ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L2 Schedule"
                (onClick)="handleButtonClick(status.L2Schedule, status.L2Pending); selectedButton = status.L2Schedule"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL2SelectedButton()"
                size="Medium"
                [type]="selectedButton === status.L2Feedback ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L2 Selected"
                (onClick)="handleButtonClick(status.L2Feedback, status.L3Pending); selectedButton = status.L2Feedback"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL3ScheduleButton()"
                size="Medium"
                [type]="selectedButton === status.L3Schedule ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L3 Schedule"
                (onClick)="handleButtonClick(status.L3Schedule, status.L3Pending); selectedButton = status.L3Schedule"
              ></emerald-button>
              <emerald-button
                *ngIf="shouldShowL3SelectedButton()"
                size="Medium"
                [type]="selectedButton === status.L3Feedback ? buttonSelection.Primary : buttonSelection.Secondary"
                Color="primary"
                label="L3 Selected"
                (onClick)="handleButtonClick(status.L3Feedback, status.Hire); selectedButton = status.L3Feedback"
              ></emerald-button>
              <emerald-button
                *ngIf="handleHireButton()"
                size="Medium"
                [type]="selectedButton === status.Hire ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Good To Hire"
                (onClick)="handleButtonClick(status.Hire, status.Hire); selectedButton = status.Hire"
              ></emerald-button>
              <emerald-button
                *ngIf="joinedButton()"
                size="Medium"
                [type]="selectedButton === status.Joined ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Joined"
                (onClick)="handleButtonClick(status.Joined, status.Joined); selectedButton = status.Joined"
              ></emerald-button>
              <emerald-button
                *ngIf="rejectButton()"
                [type]="selectedButton === status.Rejected ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Reject"
                (onClick)="handleButtonClick(status.Rejected, ''); selectedButton = status.Rejected"
              ></emerald-button>
              <emerald-button
                *ngIf="onboardingProgressButton()"
                [type]="selectedButton === status.InProgess ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Onboarding in Progress"
                (onClick)="handleButtonClick(status.InProgess, status.InProgess); selectedButton = status.InProgess"
              ></emerald-button>
              <emerald-button
                *ngIf="initiateOnboardingButton()"
                [type]="selectedButton === status.Selected ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Initiate Onboarding"
                (onClick)="handleButtonClick(status.Selected, status.Selected); selectedButton = status.Selected"
              ></emerald-button>
              
            </ng-container>
            <ng-container >
              <emerald-button
                *ngIf="noShowButton()"
                [type]="selectedButton === status.NoShow ? buttonSelection.Primary : buttonSelection.Secondary"
                label="No Show of candidate"
                (onClick)="handleButtonClick(status.NoShow, status.NoShow); selectedButton = status.NoShow"
              ></emerald-button>
              <emerald-button
                *ngIf="reschedulingRequestedButton()"
                [type]="selectedButton === status.ReschedulingRequested ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Re-scheduling requested"
                (onClick)="handleButtonClick(status.ReschedulingRequested, status.ReschedulingRequested); selectedButton = status.ReschedulingRequested"
              ></emerald-button>
              <emerald-button
                *ngIf="onHoldButton()"
                [type]="selectedButton === status.OnHold ? buttonSelection.Primary : buttonSelection.Secondary"
                label="On Hold"
                (onClick)="handleButtonClick(status.OnHold, status.OnHold); selectedButton = status.OnHold"
              ></emerald-button>
              <emerald-button
                *ngIf="othersButton()"
                [type]="selectedButton === status.Others ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Others"
                (onClick)="handleButtonClick(status.Others, status.Others); selectedButton = status.Others"
              ></emerald-button>
              <emerald-button
                *ngIf="backedOutButtonVisibility()"
                size="Medium"
                [type]="selectedButton === status.BackedOut ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Backed Out"
                (onClick)="handleButtonClick('Backed Out', status.BackedOut); selectedButton = status.BackedOut"
              ></emerald-button>
              <emerald-button
                *ngIf="droppedOutButtonVisibility()"
                size="Medium"
                [type]="selectedButton === status.DroppedOut ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Dropped Out"
                (onClick)="handleButtonClick('Dropped Out', status.DroppedOut); selectedButton = status.DroppedOut"
                [disabled]="candidateStatus === status.Joined"
              ></emerald-button>
              <emerald-button
                *ngIf="rescheduleButtonVisibility()"
                size="Medium"
                [type]="selectedButton === status.ReschedulingRequested ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Reschedule"
                (onClick)="handleButtonClick(status.ReschedulingRequested, status.ReschedulingRequested); selectedButton = status.ReschedulingRequested"
              ></emerald-button>
               <emerald-button
                *ngIf="pannelAvailability()"
                size="Medium"
                [type]="selectedButton === status.PannelsAvailability ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Pannel's Availability"
                (onClick)="handleButtonClick(status.PannelsAvailability, status.PannelsAvailability); selectedButton = status.PannelsAvailability"
              ></emerald-button>
              <emerald-button
                *ngIf="othersNewButtonVisibility()"
                size="Medium"
                [type]="selectedButton === status.Others ? buttonSelection.Primary : buttonSelection.Secondary"
                label="Others"
                (onClick)="handleButtonClick(status.Others, status.Others); selectedButton = status.Others"
              ></emerald-button>
            </ng-container>
          </div>
          <div
            *ngIf="feedbackForm.get('isButtonClicked')?.hasError('buttonNotClicked') && (feedbackForm.get('isButtonClicked')?.touched || feedbackForm.get('isButtonClicked')?.dirty)"
          >
            Please select the Action
          </div>
        </div>

        <div class="form-group" *ngIf="feedbackLvl === status.PannelsAvailability">
          <emerald-datepicker 
            class="picker-date"
            [label]="'Interview Date*'"
            [isOutlined]="true"
            [forceRefresh]="true"
            [minDate]="minDate"
            formControlName="interviewDate">
          </emerald-datepicker>
          <div
            *ngIf="feedbackForm.get('interviewDate')?.invalid && feedbackForm.get('interviewDate')?.touched"
            class="error-text"
          >
            Interview Date is required.
          </div>
        </div>

        <div class="form-group" *ngIf="feedbackLvl === status.PannelsAvailability">
          <emerald-input
            [label]="'Interview Time (HH:MM)*'"
            [outlined]="true"
            formControlName="interviewTime"
            maxlength="5"
            (input)="formatTimeInput($event)"
            placeholder="e.g., 10:00 or 14:00">
          </emerald-input>
          <div
            *ngIf="feedbackForm.get('interviewTime')?.hasError('required') && feedbackForm.get('interviewTime')?.touched"
            class="error-text"
          >
            Interview Time is required.
          </div>
          <div
            *ngIf="feedbackForm.get('interviewTime')?.hasError('invalidTime') && feedbackForm.get('interviewTime')?.touched"
            class="error-text"
          >
            Please enter a valid time in 24-hour format.
          </div>
        </div>

        <div class="form-group" *ngIf="feedbackLvl === status.PannelsAvailability">
          <emerald-dropdown
            [label]="'Interview Mode*'"
            [outlined]="true"
            [isValid]="true"
            formControlName="interviewMode"
            [options]="interviewModeOptions"
            [id]="'interview_mode_select'"
            [preSelectedLabel]="'label'"
            [preSelectedValue]="'value'">
          </emerald-dropdown>
          <div
            *ngIf="feedbackForm.get('interviewMode')?.hasError('required') && feedbackForm.get('interviewMode')?.touched"
            class="error-text"
          >
            Interview Mode is required.
          </div>
        </div>

        <div class="form-group" *ngIf="hidingForm() && feedbackLvl !== status.PannelsAvailability">
          <textarea
            id="feedbackComment"
            placeholder="Feedback/Comment*"
            class="form-input"
            required
            aria-required="true"
            rows="4"
            formControlName="feedbackComment"
            name="feedbackComment"
          ></textarea>
          <div
            *ngIf="feedbackForm.get('feedbackComment')?.invalid && feedbackForm.get('feedbackComment')?.touched"
            class="error-text"
          >
            Feedback/Comment is required.
          </div>
        </div>
      </form>
    </ng-container>
  </section>
  <ng-container actions *ngIf="hidingForm()">
    <div class="form-actions">
      <span class="mdc-dialog__button">
        <emerald-button
          size="Small"
          type="Secondary"
          Color="primary"
          (onClick)="opened = false; cancel()"
          label="Cancel"
        ></emerald-button>
      </span>
      <span class="mdc-dialog__button">
        <emerald-button
          size="Small"
          type="Primary"
          Color="primary"
          (onClick)="submitFeedback()"
          label="Submit"
        ></emerald-button>
      </span>
    </div>
  </ng-container>
</emerald-modal>
